import React from 'react';
import { Box } from '@mui/material';
import { tokens } from '../../theme';

const STATUS_CONFIG = {
  active:    { label: 'Activo',      ...tokens.color.status.active },
  suspended: { label: 'Suspendido',  ...tokens.color.status.suspended },
  offline:   { label: 'Offline',     ...tokens.color.status.offline },
  pending:   { label: 'Pendiente',   ...tokens.color.status.pending },
};

// dot — para columnas de tabla donde el espacio es crítico
// badge — con texto completo
const StatusBadge = ({ status, variant = 'badge' }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.offline;

  if (variant === 'dot') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            backgroundColor: cfg.text,
            flexShrink: 0,
          }}
        />
        <Box
          component="span"
          sx={{
            fontSize: '0.8125rem',
            fontWeight: 500,
            color: cfg.text,
          }}
        >
          {cfg.label}
        </Box>
      </Box>
    );
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: '8px',
        py: '3px',
        borderRadius: tokens.radius.sm,
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1.4,
        letterSpacing: '0.01em',
        color: cfg.text,
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        whiteSpace: 'nowrap',
      }}
    >
      {cfg.label}
    </Box>
  );
};

export default StatusBadge;
